module.exports = __webpack_public_path__ + "static/media/part1.ee47d996.png";